import { m } from 'framer-motion';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
import useResponsive from '../../../hooks/useResponsive';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';

DetailEmbededVideo.propTypes = {
  media: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.string,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailEmbededVideo({ media, description }) {
  const isMobile = useResponsive('down', 'sm');
  const [link, setLink] = useState(media);
  const [validLink, setValidLink] = useState(false);

  useEffect(() => {
    if (link.includes('watch')) {
      setLink(link.replace('watch?v=', 'embed/'));
    } else if (link.includes('youtu.be')) {
      setLink(link.replace('youtu.be/', 'youtube.com/embed/'));
    } /* else {
      setLink(link); // toto nema ziaden vyznam
    } */
    setValidLink(true);
  }, [link]);

  return (
    <RootStyle>
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /* variants={varFade().inUp} */>
          <Grid container>
            <Grid item xs={12} className="text-center">
              {validLink && (
                <iframe
                  width="100%"
                  style={{ borderRadius: '12px' }}
                  height={isMobile ? '300' : '500'}
                  src={link}
                  title="video player"
                  frameBorder="0"
                  allowFullScreen
                />
              )}
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} className="text-center">
              <Typography variant="subtitle2" sx={{ padding: '6px' }}>
                {description}
              </Typography>
            </Grid>
          </Grid>
        </m.div>
      </Container>
    </RootStyle>
  );
}
